import { Form } from 'antd';
import { Input } from '@admin-panel/ui';
import { SectionHeading, labelNode } from '../helpers';

type OccasionSectionProps = {
  showHeading: boolean;
};

const OccasionSection = ({ showHeading }: OccasionSectionProps) => (
  <section className="space-y-3">
    {showHeading ? <SectionHeading title="Occasion" /> : null}
    <Form.Item label={labelNode('Occasion Name')} name="occasion_name" style={{ marginBottom: 0 }}>
      <Input placeholder="Occasion name" disabled />
    </Form.Item>
    <Form.Item label={labelNode('Sub Occasion Name')} name="sub_occasion_name" style={{ marginBottom: 0 }}>
      <Input placeholder="Sub occasion name" disabled />
    </Form.Item>
  </section>
);

export default OccasionSection;
